import React from 'react';
import { observer } from 'mobx-react-lite';
import { RulerUI } from '../features/ruler/ui/ruler-ui';

export const RulerObserver: React.FC = observer(() => {
  return <RulerUI />;
});
